import balcones from "../images/balcones.webp";
import chronic_pelvic from "../images/chronic_pelvic.webp";
import pinnacle from "../images/pinnacle.webp";

export const galleryObjects = [
  {
    title: "Pinnacle Care Internal Medicine",
    imgSrc: pinnacle,
    link: "https://www.pinnaclecareinternalmedicine.net/",
  },

  {
    title: "The Chronic Pelvic Pain Center of North Virginia",
    imgSrc: chronic_pelvic,
    link: "https://www.pelvicpaindr.com/",
    paragraph:
      "Implemented design based on Figma file provided by outside designer",
  },
  {
    title: "Balcones Dermatology",
    imgSrc: balcones,
    link: "https://www.balconesdermatology.com/",
  },
];
